<template>
  <img
    v-if="logoUrl"
    :src="logoUrl"
    alt="Logo"
    class="max-h-10 max-w-32 object-contain"
  >
  <span
    v-else
    class="text-xl font-bold text-gray-700"
  >
    Cityzen
  </span>
</template>

<script>
export default {
  name: 'ProjectLogo',
  props: {
    logoUrl: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
